import type { CustomFieldEntity } from './__generated__/FieldSettingsView.graphql';

export const DEFAULT_ENTITY: CustomFieldEntity = 'PROJECT';
